import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchDeliveryProcess(service_provider_id, delivery_process_id) {
    return RequesterV1.get(
      `service_provider/delivery/managing/${service_provider_id}/show_process/${delivery_process_id}`
    );
  },

  fetchOrder(service_provider_id, delivery_process_id, order_id) {
    return RequesterV1.get(
      `service_provider/delivery/managing/${service_provider_id}/manage_orders/${delivery_process_id}/fetch_order/${order_id}`
    );
  },

  fetchDeliveryProducts(service_provider_id, delivery_process_id) {
    return RequesterV1.get(
      `service_provider/delivery/managing/${service_provider_id}/manage_orders/${delivery_process_id}/fetch_delivery_products`
    );
  },

  fetchDeliveryProcessCustomers(service_provider_id, delivery_process_id) {
    return RequesterV1.get(
      `service_provider/delivery/managing/${service_provider_id}/manage_orders/${delivery_process_id}/fetch_delivery_process_customers`
    );
  },

  create(service_provider_id, delivery_process_id, order) {
    return RequesterV1.post(
      `service_provider/delivery/managing/${service_provider_id}/manage_orders/${delivery_process_id}/create`,
      { order }
    );
  },

  update(
    service_provider_id,
    delivery_process_id,
    order_id,
    order
  ) {
    return RequesterV1.post(
      `service_provider/delivery/managing/${service_provider_id}/manage_orders/${delivery_process_id}/update/${order_id}`,
      { order }
    );
  },

  destroy(service_provider_id, delivery_process_id, order_id) {
    return RequesterV1.delete(
      `service_provider/delivery/managing/${service_provider_id}/manage_orders/${delivery_process_id}/destroy/${order_id}`
    );
  },
};
